export const DEFAULT_DOMAIN = "https://app.referralsaasquatch.com";
export const DEFAULT_NPM_CDN = "https://fast.ssqt.io/npm";
export const DEFAULT_NAMESPACE = "squatch";
export const IMPACT_NAMESPACE = "impact";
